import { actionType } from './actions';

const initialState = {
    addNewTrust: {
        edgarCik: '',
        name: '',
        formerlyKnownAsNames: '',
        clientId: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        countryId: '',
        clientCode: '',
        fundGroupCode: '',
        sec33ActFileNumber: '',
        sec40ActFileNumber: '',
        federalId: ''
    },
    editTrust: {
        trustId: '',
        edgarCik: '',
        name: '',
        formerlyKnownAsNames: '',
        clientId: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        countryId: '',
        clientCode: '',
        fundGroupCode: '',
        sec33ActFileNumber: '',
        sec40ActFileNumber: '',
        federalId: ''
    },
    viewTrust: {
        trustId: '',
        edgarCik: '',
        name: '',
        formerlyKnownAsNames: '',
        clientId: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        countryId: '',
        clientCode: '',
        fundGroupCode: '',
        sec33ActFileNumber: '',
        sec40ActFileNumber: '',
        federalId: ''
    },
    selectedHistoryItem: {},
    trusts: [],
    filings: [],
    sales: [],
    adminSales: [],
    history: [],
    addTrustVisibility: false,
    editTrustVisibility: false,
    viewTrustVisibility: false,
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_TRUST_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_TRUST_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_TRUST: {
            return {
                ...state,
                editTrust: action.payload,
                viewTrust: action.payload,
                sales: [],
                adminSales: [],
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_TRUST_FILINGS: {
            return {
                ...state,
                filings: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_TRUST_SALES: {
            return {
                ...state,
                sales: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_TRUST_ADMIN_SALES: {
            return {
                ...state,
                adminSales: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_TRUST_HISTORY: {
            return {
                ...state,
                history: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_TRUST_BY_CLIENT: {
            return {
                ...state,
                trusts: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.ADD_NEW_TRUST: {
            return {
                ...state,
                trusts: [action.payload, ...state.trusts],
                addedTrust: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.EDIT_TRUST: {
            return {
                ...state,
                trusts: state.trusts.map(trust => {
                    if (trust.trustId === action.payload.trustId) {
                        return action.payload;
                    }
                    return trust;
                }),
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_ADD_NEW_TRUST_PAYLOAD: {
            return {
                ...state,
                addNewTrust: action.payload
            };
        }

        case actionType.CLEAR_TRUSTS_LIST: {
            return {
                ...state,
                trusts: []
            };
        }

        case actionType.UPDATE_TRUST_HISTORY_ITEM_SELECTED: {
            return {
                ...state,
                selectedHistoryItem: action.payload
            };
        }

        case actionType.UPDATE_EDIT_TRUST_PAYLOAD: {
            return {
                ...state,
                editTrust: action.payload
            };
        }

        case actionType.HANDLE_ADD_TRUST_VISIBILITY: {
            return {
                ...state,
                addTrustVisibility: action.visibility,
                addNewTrust: {
                    edgarCik: '',
                    name: '',
                    formerlyKnownAsNames: '',
                    clientId: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    postalCode: '',
                    countryId: '',
                    clientCode: '',
                    fundGroupCode: '',
                    sec33ActFileNumber: '',
                    sec40ActFileNumber: ''
                }
            };
        }

        case actionType.HANDLE_EDIT_TRUST_VISIBILITY: {
            return {
                ...state,
                editTrustVisibility: action.visibility
            };
        }

        case actionType.HANDLE_VIEW_TRUST_VISIBILITY: {
            return {
                ...state,
                viewTrustVisibility: action.visibility
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/trust/reducers.js